/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TopicInputs */

const en__field_topic = /** @type {(inputs: _Field_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic`)
};

const de__field_topic = /** @type {(inputs: _Field_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema`)
};

/**
* | output |
* | --- |
* | "Topic" |
*
* @param {_Field_TopicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_topic = /** @type {((inputs?: _Field_TopicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TopicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_topic(inputs)
	return de__field_topic(inputs)
});